import { useState, FormEvent } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { apiError } from "@/lib/api";
import { useAuth } from "./AuthContext";
import { AccMark } from "@/components/site/AccMark";
import { useSeo } from "@/lib/seo";

export default function Login() {
  useSeo({ title: "Staff login | All Concept Concrete", description: "", noindex: true });
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/staff" replace />;

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/staff");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#0F1115] grid-lines px-5">
      <form onSubmit={submit} data-testid="login-form" className="w-full max-w-sm border border-slate-800 bg-[#161920] p-8">
        <div className="mb-6 flex items-center gap-3">
          <AccMark className="h-10 w-auto" />
          <div>
            <h1 className="text-2xl font-bold uppercase text-white">Staff login</h1>
            <p className="font-mono text-xs text-slate-500">All Concept Concrete lead desk</p>
          </div>
        </div>
        <div className="space-y-3">
          <input className="field" type="email" placeholder="Email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
          <input className="field" type="password" placeholder="Password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
          {error && <p className="text-sm text-red-400" data-testid="login-error">{error}</p>}
          <button type="submit" className="btn-brand w-full" disabled={busy} data-testid="login-submit-button">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
          </button>
        </div>
      </form>
    </div>
  );
}
